// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610091106/js/" + chunkId + "." + {"44":"f4a3a12b","225":"b0cb3a25","481":"dbdef605","486":"1e44c004","770":"bbcbe2ad"}[chunkId] + ".0.63113000519898.chunk.js";
};